const state = {};
const getters = {};
const actions = {
    async getItems({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/dashboard/six-monthly-safety-hazard-inspection`, {params:params})
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    async getIssueLists({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/dashboard/six-monthly-safety-hazard-inspection-issue-list`, {params:params})
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    async getJobLists({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/dashboard/six-monthly-safety-hazard-inspection-job-list`, {params:params})
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
};

const mutations = {};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}